module.exports = __webpack_public_path__ + "static/4-91ce1fcd88c595291b1109f8b7bc869c.jpg";